<form class="row" [formGroup]="form">
  <div [class]="!hiddenFields['dropoffAddress'] ? 'col-lg-6' : 'col-12'">
    <div
      class="address-tab-header mb-2 d-flex justify-content-center align-items-center"
    >
      <span class="text-white">{{
        "case.address-informations.pickup-header" | translate
      }}</span>
    </div>
    <div class="mb-2" *ngIf="!hiddenFields['pickupInstitution']">
      <label class="form-label" for="">
        {{ "case.address-informations.institution" | translate }}
      </label>
      @if(isReadOnly){
      <app-readonly-input
        [value]="readonlyInformations?.pickupInstitution?.label"
      ></app-readonly-input>
      }@else{
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="institutions"
        formControlName="pickupInstitution"
        [filter]="true"
        appendTo="body"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [loading]="!institutions || institutions.length === 0"
        (onChange)="onInstitutionChange('pickup')"
        [showClear]="true"
        [placeholder]="'case.address-informations.institution' | translate"
      ></p-dropdown>
      }
    </div>

    <div class="mb-2" *ngIf="!hiddenFields['pickupAddress']">
      <case-address-autocomplete
        #pickupAddress
        (addressChangeOn)="handleSetAddress($event, 'pickup')"
        [disableAll]="form.controls['pickupInstitution'].value"
        [patient]="patient"
        [isReadOnly]="isReadOnly"
      ></case-address-autocomplete>
    </div>

    <div class="warning-container" *ngIf="bridgeInfos && !hiddenFields['dropoffAddress']">
      <div class="warning-row">
    
        <div class="warning-header">
          {{ "case.address-informations.warnings" | translate }}
        </div>
    
        <div class="warning-content">
          <div class="warning-layout">
            <div class="warning-left-column">
              <div class="warning-item">
                <div class="warning-label">{{ "case.address-informations.region" | translate }}</div>
                <div class="warning-separator">: {{ bridgeInfos?.regionNumber }}</div>
              </div>
    
              <div class="warning-item">
                <div class="warning-label">{{ "case.address-informations.has-bridge" | translate }}</div>
                <div class="warning-separator">
                  : {{
                  bridgeInfos?.isBrigdePass
                  ? ("case.address-informations.yes-bridge" | translate)
                  : ("case.address-informations.no-bridge" | translate)
                  }}
                </div>
              </div>
            </div>
    
            <div class="warning-description">
              {{ bridgeInfos?.description }}
            </div>
          </div>
        </div>
    
      </div>
    </div>

  </div>

  <div class="col-lg-6 divider-col" *ngIf="!hiddenFields['dropoffAddress']">
    <div
      class="address-tab-header mb-2 d-flex justify-content-center align-items-center"
    >
      <span class="text-white">{{
        "case.address-informations.dropoff-header" | translate
      }}</span>
    </div>
    <div class="mb-2" *ngIf="!hiddenFields['dropoffInstitution']">
      <label class="form-label" for="">
        {{ "case.address-informations.institution" | translate }}
      </label>

      @if(isReadOnly){
      <app-readonly-input
        [value]="readonlyInformations?.dropoffInstitution?.label"
      ></app-readonly-input>
      }@else{
      <p-dropdown
        [style]="{ width: '100%' }"
        [options]="institutions"
        formControlName="dropoffInstitution"
        [filter]="true"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [loading]="!institutions || institutions.length === 0"
        appendTo="body"
        (onChange)="onInstitutionChange('dropoff')"
        [placeholder]="'case.address-informations.institution' | translate"
      ></p-dropdown>
      }
    </div>
    <div class="mb-3" *ngIf="!hiddenFields['dropoffAddress']">
      <case-address-autocomplete
        #dropoffAddress
        [disableAll]="form.controls['dropoffInstitution'].value"
        (addressChangeOn)="handleSetAddress($event, 'dropoff')"
        [patient]="patient"
        [isReadOnly]="isReadOnly"
      ></case-address-autocomplete>
    </div>
    <div class="row" *ngIf="!hiddenFields['dropoffAddress']">
      <div class="col-md-4">
        <label for="gender" class="form-label me-2">{{
          "case.address-informations.institution-approval" | translate
        }}</label>

        @if(isReadOnly){ @if(!readonlyInformations?.dropoffInstitutionApproval){
        <i class="fa fa-xmark" style="color: red"></i>
        }@else{
        <i class="fa fa-check" style="color: green"></i>
        } }@else {
        <input
          type="checkbox"
          id="kimliksiz"
          class="form-check-input"
          formControlName="dropoffInstitutionApproval"
        />
        }
      </div>
      <div class="col-md-8">
        @if(isReadOnly){
        <app-readonly-input
          [value]="readonlyInformations?.dropoffInstitutionDescription"
          [type]="'textarea'"
        ></app-readonly-input>
        }@else {
        <textarea
          formControlName="dropoffInstitutionDescription"
          class="form-control"
          rows="3"
          id="addressDescription"
          [placeholder]="'case.address-informations.description' | translate"
        ></textarea>
        }
      </div>
    </div>
  </div>
</form>
